import * as React from "react";

interface Props {
  style?: React.CSSProperties;
  className?: string;
}
export const VolumeSetIcon: React.FC<Props> = ({ style = {}, className = "" }) => {
  return (
    <svg
      style={style}
      className={className}
      id="Layer_1"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="m256 91c-125.933.131-182.768 159.088-85.955 239.08l28.238-16.943c13.39-8.034 28.614 7.19 20.58 20.58l-11.058 18.431c86.272 34.375 184.542-33.104 183.195-126.15 0-74.437-60.561-134.998-135-134.998zm0 190c-30.327 0-55-24.673-55-55 2.765-72.865 107.246-72.845 110 .001 0 30.326-24.673 54.999-55 54.999z" />
        <path d="m256 201c-13.785 0-25 11.215-25 25 1.257 33.12 48.748 33.111 50 0 0-13.785-11.215-25-25-25z" />
        <path d="m114.837 417.163c6.023 6.023 16.103 4.782 20.485-2.522l26.945-44.909-44.909 26.945c-7.303 4.383-8.544 14.463-2.521 20.486z" />
        <path d="m436 0h-360c-30.327 0-55 24.673-55 55v402c0 30.327 24.673 55 55 55h360c30.327 0 55-24.673 55-55v-402c0-30.327-24.673-55-55-55zm-340 61c8.284 0 15 6.716 15 15-.735 19.876-29.268 19.87-30 0 0-8.284 6.716-15 15-15zm200 390c-8.284 0-15-6.716-15-15 .735-19.876 29.268-19.87 30 0 0 8.284-6.716 15-15 15zm60 0c-8.284 0-15-6.716-15-15 .735-19.876 29.268-19.87 30 0 0 8.284-6.716 15-15 15zm-100-60c-21.908 0-43.705-4.412-63.811-12.828l-31.142 51.904c-14.424 24.04-47.6 28.124-67.423 8.3-19.824-19.824-15.74-52.999 8.3-67.423l41.151-24.69c-108.351-100.478-35.282-286.044 112.928-285.262 218.583 8.289 218.538 321.736-.003 329.999zm160 60c-8.284 0-15-6.716-15-15 .735-19.876 29.268-19.87 30 0 0 8.284-6.716 15-15 15zm0-360c-8.284 0-15-6.716-15-15 .735-19.876 29.268-19.87 30 0 0 8.284-6.716 15-15 15z" />
      </g>
    </svg>
  );
};
